"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
exports.iconDefinitions = new Map([
    // https://thenounproject.com/search/?q=settings&i=1939578
    [
        'settings',
        {
            paths: [
                'M86.29,37.3l-1.7-4.12c5.83-13.45,5.45-13.85,4.31-15l-7.45-7.43-0.74-.64H79.85c-0.46,0-1.81,0-13.14,5.24l-4.17-1.72C57.15,0,56.6,0,55,0H44.51c-1.58,0-2.19,0-7.18,13.68L33.18,15.4c-7.65-3.3-12.14-5-13.35-5l-1,0-8,8C9.6,19.65,9.17,20.06,15.34,33.3l-1.7,4.11C0,42.79,0,43.31,0,45V55.48c0,1.65,0,2.23,13.69,7.24l1.7,4.1c-5.83,13.45-5.44,13.85-4.31,15l7.45,7.44,0.74,0.65h0.87c0.45,0,1.79,0,13.13-5.25l4.16,1.73C42.82,100,43.37,100,45,100H55.47c1.61,0,2.18,0,7.19-13.67l4.17-1.72c7.65,3.3,12.12,5,13.33,5l1,0,8.08-8.07c1.15-1.18,1.55-1.59-4.58-14.78l1.69-4.11C100,57.21,100,56.64,100,55V44.52C100,42.87,100,42.29,86.29,37.3ZM50,67.49A17.5,17.5,0,1,1,67.46,50,17.52,17.52,0,0,1,50,67.49Z',
            ],
            width: 100,
            height: 100,
        },
    ],
    // handrolled, let's face it... it's a couple of lines...
    [
        'add',
        {
            paths: ['M 44.24,2 V 44.239962 H 2 V 55.76 H 44.24 V 98 H 55.76 V 55.76 H 98 V 44.239962 H 55.76 V 2 Z'],
            width: 100,
            height: 100,
        },
    ],
    // handrolled
    [
        'minus',
        {
            paths: ['M2 44.24V55.76H98V44.24H2Z'],
            width: 100,
            height: 100,
        },
    ],
    // https://thenounproject.com/search/?q=edit&i=1137659
    [
        'edit',
        {
            paths: [
                'm1.637,30.363c-0.26,0 -0.516,-0.101 -0.708,-0.293c-0.304,-0.304 -0.38,-0.769 -0.188,-1.154l2.828,-5.657c0.048,-0.096 0.111,-0.184 0.188,-0.26l19.093,-19.092c0.593,-0.594 1.316,-0.907 2.089,-0.907c1.213,0 2.354,0.784 2.837,1.95c0.461,1.114 0.206,2.31 -0.683,3.199l-19.092,19.092c-0.076,0.076 -0.164,0.139 -0.26,0.188l-5.657,2.829c-0.142,0.071 -0.295,0.105 -0.447,0.105zm3.65,-6.065l-1.414,2.829l2.829,-1.415l18.977,-18.977c0.315,-0.315 0.399,-0.658 0.25,-1.02c-0.17,-0.407 -0.595,-0.715 -0.99,-0.715c-0.235,0 -0.462,0.108 -0.675,0.321l-18.977,18.977z',
                'm23.557,11.271c-0.256,0 -0.512,-0.098 -0.708,-0.293l-2.828,-2.829c-0.39,-0.391 -0.39,-1.024 0,-1.415c0.391,-0.39 1.024,-0.39 1.415,0l2.828,2.829c0.39,0.391 0.39,1.024 0,1.415c-0.195,0.196 -0.451,0.293 -0.707,0.293z',
            ],
            width: 32,
            height: 32,
        },
    ],
    // https://thenounproject.com/search/?q=delete&i=2844896
    [
        'delete',
        {
            paths: [
                'M357,428.9c-35,0-70,0-105.1,0c-36.3,0-72.6,0.6-108.9,0c0,0-0.1,0-0.1,0c-0.5,0-0.9,0-1.4,0      c-2.3-0.2-1.8-0.1,1.2,0.3c0,0.1-2.8-0.6-2.6-0.5c-1-0.2-2.2-0.9-3.2-0.9c-2.4-0.2,4,2.3,0.5,0.2c-0.7-0.4-1.5-0.8-2.3-1.3      c-4.2-2.5-0.3,0.2-0.2,0.1c-0.1,0-4.8-4.2-4.6-4.6c0.2-0.3,2.4,4,0.5,0.4c-0.5-1-1.1-1.9-1.6-2.8c-1.9-3.4,0.7,1.1,0.4,1.2      c-0.2,0-1.1-3.5-1.2-3.8c-0.2-0.8-0.2-1.9-0.5-2.6c1.7,4.5,0.3,1.8,0.3-0.2c0-2.2,0-4.4,0-6.6c0-14.9,0-29.7,0-44.6      c0-49.9,0-99.7,0-149.6c0-33.6,0.8-67.4,0-101c0-0.5,0-1.1,0-1.6c-6.7,6.7-13.3,13.3-20,20c32,0,63.9,0,95.9,0      c50.9,0,101.8,0,152.6,0c11.6,0,23.2,0,34.8,0c-6.7-6.7-13.3-13.3-20-20c0,38.7,0,77.4,0,116.1c0,55.5,0,111,0,166.5      c0,6.4,0,12.9,0,19.3c0,0.5,0,0.9,0,1.4c0,0.5,0,1.1,0,1.5c0.1,4.6,1.2-4.3,0.1,0.1c-0.1,0.5-1.1,5.2-1.4,5.1      c0.3-0.8,0.7-1.6,1-2.3c-0.4,0.8-0.8,1.6-1.2,2.3c-0.1,0.2-1.9,3.4-2.1,3.3c0.5-0.7,1-1.3,1.5-2c-0.6,0.7-1.1,1.3-1.7,1.9      c-0.6,0.6-1.2,1.2-1.9,1.8c-1.6,1.4-1.3,1.1,1-0.7c0.1,0.2-3,1.9-3.3,2.1c-0.8,0.4-1.5,0.8-2.3,1.2c2.8-1.1,3.1-1.3,1.1-0.6      c-1.3,0.3-2.6,0.7-3.9,1c-2.2,0.4-1.8,0.3,1.3-0.2C358.9,428.9,358,428.9,357,428.9c-10.5,0.2-20.5,9.1-20,20      c0.5,10.7,8.8,20.2,20,20c30.1-0.6,54.1-24.5,54.6-54.6c0.1-3.6,0-7.3,0-10.9c0-22,0-44,0-66c0-60.7,0-121.4,0-182.1      c0-14.8,0-29.6,0-44.4c0-10.8-9.2-20-20-20c-32,0-63.9,0-95.9,0c-50.9,0-101.8,0-152.6,0c-11.6,0-23.2,0-34.8,0      c-10.8,0-20,9.2-20,20c0,28.9,0,57.8,0,86.8c0,51.1,0,102.3,0,153.4c0,17.3,0,34.6,0,51.9c0,3.5,0,7.1,0,10.6      c0.1,16.1,6.8,32,19.4,42.3c11,8.9,23.6,13,37.7,13c5.9,0,11.8,0,17.6,0c22.4,0,44.7,0,67.1,0c41.5,0,83,0,124.5,0      c0.8,0,1.6,0,2.4,0c10.5,0,20.5-9.2,20-20C376.6,438.1,368.3,428.9,357,428.9z',
                'M63.5,130.1c12.4,0,24.8,0,37.2,0c29.6,0,59.2,0,88.9,0c36,0,72,0,108,0c31,0,62,0,93,0      c15.1,0,30.3,0.4,45.4,0c0.2,0,0.4,0,0.6,0c10.5,0,20.5-9.2,20-20c-0.5-10.8-8.8-20-20-20c-12.4,0-24.8,0-37.2,0      c-29.6,0-59.2,0-88.9,0c-36,0-72,0-108,0c-31,0-62,0-93,0c-15.1,0-30.3-0.4-45.4,0c-0.2,0-0.4,0-0.6,0c-10.5,0-20.5,9.2-20,20      C43.9,120.9,52.2,130.1,63.5,130.1L63.5,130.1z',
                'M200.3,110c0-6.5,0-13.1,0-19.6c0-4,0-8,0-12c0-1.1,0-2.1,0-3.2c0-0.1,0-0.3,0-0.4c0-0.8,0.5-2.7-0.2-0.1     c-0.8,3.3,0.3-1,0.4-1.3c0.7-3.3-1.9,2.7,0-0.1c-0.1,0.2,1.3-2.3,1.4-2.2c0.4,0.2-2.9,2.9-1.1,1.5c0.6-0.5,1.4-1.2,1.8-1.8     c1.4-1.8-1.3,1.5-1.5,1.1c0-0.1,1.5-1,1.7-1c3.5-1.9,0.3,0.4-0.6,0.1c0.3,0.1,6.3-1.7,2.6-0.8c-2.6,0.7-0.7,0.1,0.2,0.2     c0.3,0,0.7,0,1.1,0c5.1,0,10.3,0,15.4,0c17.7,0,35.3,0,53,0c6.4,0,12.8,0,19.1,0c1.2,0,2.4,0.1,3.5,0c0.1,0,1.4,0.1,1.5,0     c-0.9,0.9-4.1-0.9-1.3-0.1c0.6,0.2,1.3,0.4,1.9,0.5c2.5,0.4-3.1-2-1.1-0.5c0.5,0.4,1.2,0.7,1.7,0.9c0.5,0.3,2.6,1.1,0.1-0.1     c-2.5-1.2,0.2,0.4,0.9,1c0.8,0.7,1,2,0.1,0c-1.3-2.8,0.2,0.6,0.6,1.2c1,1.5-0.2,1.3,0.1,0c-0.6-1.6-0.7-1.6-0.1,0.1     c0.1,0.4,0.2,0.9,0.3,1.3c1.1,3.6,0.1-3.9-0.1,0.2c0,0.3,0,0.6,0,0.8c0,3.8,0,7.6,0,11.3c0,7.7,0,15.4,0,23.1     c0,10.5,9.2,20.5,20,20c10.8-0.5,20-8.8,20-20c0-7.4,0-14.7,0-22.1c0-10.3,0.6-20.5-3.5-30.2c-7.1-16.8-23.1-27.2-41.3-27.6     c-4.8-0.1-9.6,0-14.4,0c-19,0-38,0-57,0c-19.1,0-39.3-1.6-53.4,14.5c-7.5,8.5-11.5,18.8-11.7,30.1c-0.1,3.1,0,6.3,0,9.4     c0,8.6,0,17.2,0,25.8c0,10.5,9.2,20.5,20,20C191.1,129.6,200.3,121.3,200.3,110L200.3,110z',
                'M185.8,203.3c0,44.6,0,89.3,0,133.9c0,6.4,0,12.8,0,19.3c0,10.5,9.2,20.5,20,20c10.8-0.5,20-8.8,20-20      c0-44.6,0-89.3,0-133.9c0-6.4,0-12.8,0-19.3c0-10.5-9.2-20.5-20-20C195,183.8,185.8,192.1,185.8,203.3L185.8,203.3z',
                'M274.2,203.3c0,44.6,0,89.3,0,133.9c0,6.4,0,12.8,0,19.3c0,10.5,9.2,20.5,20,20c10.8-0.5,20-8.8,20-20      c0-44.6,0-89.3,0-133.9c0-6.4,0-12.8,0-19.3c0-10.5-9.2-20.5-20-20C283.3,183.8,274.2,192.1,274.2,203.3L274.2,203.3z',
            ],
            width: 500,
            height: 500,
        },
    ],
    // Ayvri Chevron Icon
    [
        'chevron',
        {
            paths: ['M 9,11.835294 14.835294,6 v 1.4142136 l -4.426715,4.4267144 4.426715,4.498114 v 1.425664 z'],
            width: 24,
            height: 24,
        },
    ],
    // handcrafted
    [
        'indicator',
        {
            paths: [
                'M 2,0 C 0.892,0 0,0.892 0,2 v 15 l 5,6 5,-6 V 2 C 10,0.892 9.108,0 8,0 Z m 0.5,5.5 h 2 v 2 h -2 z m 3,0 h 2 v 2 h -2 z m -3,3 h 2 v 2 h -2 z m 3,0 h 2 v 2 h -2 z m -3,3 h 2 v 2 h -2 z m 3,0 h 2 v 2 h -2 z',
            ],
            width: 10,
            height: 23,
        },
    ],
    // https://thenounproject.com/search/?q=close&i=2322026
    [
        'close',
        {
            paths: [
                'M12.7071068,12 L20.131728,19.4246212 L19.4246212,20.131728 L12,12.7071068 L4.5753788,20.131728 L3.86827202,19.4246212 L11.2928932,12 L3.86827202,4.5753788 L4.5753788,3.86827202 L12,11.2928932 L19.4246212,3.86827202 L20.131728,4.5753788 L12.7071068,12 Z',
            ],
            width: 24,
            height: 24,
        },
    ],
    // https://thenounproject.com/search/?q=play&i=2351591
    [
        'play',
        {
            paths: [
                'M19.54,11.16l-14-9c-0.31-0.2-0.7-0.21-1.02-0.04C4.2,2.3,4,2.63,4,3v18c0,0.37,0.2,0.7,0.52,0.88C4.67,21.96,4.84,22,5,22   c0.19,0,0.38-0.05,0.54-0.16l14-9C19.83,12.66,20,12.34,20,12C20,11.66,19.83,11.34,19.54,11.16z',
            ],
            width: 24,
            height: 24,
        },
    ],
    // https://thenounproject.com/search/?q=pause&creator=4147055&i=1921038
    [
        'pause',
        {
            paths: [
                'M12,6H7C6.45,6,6,6.45,6,7v18c0,0.55,0.45,1,1,1h5c0.55,0,1-0.45,1-1V7C13,6.45,12.55,6,12,6z',
                'M25,6h-5c-0.55,0-1,0.45-1,1v18c0,0.55,0.45,1,1,1h5c0.55,0,1-0.45,1-1V7C26,6.45,25.55,6,25,6z',
            ],
            width: 32,
            height: 32,
        },
    ],
    // https://thenounproject.com/search/?q=next&i=509914
    [
        'next',
        {
            paths: [
                'M224.8,165.9c18.6,16.5,37.1,33,55.7,49.6c29.4,26.2,58.8,52.4,88.3,78.6c6.8,6,13.5,12,20.3,18.1c0-14.1,0-28.3,0-42.4    c-18.5,16.2-37,32.4-55.5,48.6c-29.5,25.8-59,51.7-88.4,77.5c-6.8,5.9-13.5,11.8-20.3,17.8c-11.8,10.4-11.4,32,0,42.4    c12.6,11.6,29.8,11.1,42.4,0c18.5-16.2,37-32.4,55.5-48.6c29.5-25.8,59-51.7,88.4-77.5c6.8-5.9,13.5-11.8,20.3-17.8    c11.7-10.3,11.5-32.2,0-42.4c-18.6-16.5-37.1-33-55.7-49.6c-29.4-26.2-58.8-52.4-88.3-78.6c-6.8-6-13.5-12-20.3-18.1    c-11.7-10.4-31-12.4-42.4,0C214.4,134.9,212.3,154.8,224.8,165.9L224.8,165.9z',
            ],
            width: 612,
            height: 612,
        },
    ],
    // https://thenounproject.com/search/?q=add%20images&i=848555
    [
        'add-photos',
        {
            paths: [
                'M52.558,74.693H43.62v-8.938c0-0.828-0.672-1.5-1.5-1.5s-1.5,0.672-1.5,1.5v8.938h-8.938c-0.828,0-1.5,0.672-1.5,1.5  s0.672,1.5,1.5,1.5h8.938v8.938c0,0.828,0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5v-8.938h8.938c0.828,0,1.5-0.672,1.5-1.5  S53.386,74.693,52.558,74.693z M27.116,2.869l-4.303,15.396H8.507v65.34h14.057c3.002,7.893,10.624,13.525,19.557,13.525  c8.932,0,16.553-5.633,19.555-13.525h14.141v-4.635L91.47,19.594l0.023-0.082L27.116,2.869z M31.146,9.682l33.203,8.584H28.81  L31.146,9.682z M42.12,94.131c-9.891,0-17.938-8.047-17.938-17.938s8.047-17.938,17.938-17.938c9.89,0,17.936,8.047,17.936,17.938  S52.01,94.131,42.12,94.131z M70.112,64.67h-10.53c-3.751-5.666-10.174-9.414-17.462-9.414c-7.289,0-13.712,3.748-17.463,9.414  H14.21V52.229c0.059-0.033,0.123-0.07,0.182-0.113l19.1-13.992l3.367,3.193c0.621,0.588,1.602,0.566,2.195-0.047  c0.59-0.611,0.568-1.584-0.049-2.17l-4.316-4.09c-0.545-0.516-1.389-0.568-1.994-0.125L14.21,48.428v-2.182  c0.045-0.027,0.09-0.059,0.133-0.09l18.334-13.766l18.588,16.219c0.295,0.256,0.66,0.383,1.027,0.383  c0.406,0,0.814-0.158,1.117-0.471l7.66-7.893l9.043,5.639V64.67z M70.112,42.639l-8.461-5.275c-0.621-0.389-1.434-0.289-1.943,0.236  l-7.506,7.734L33.776,29.258c-0.555-0.484-1.375-0.514-1.963-0.072L14.21,42.402v-18.49h55.902V42.639z M75.815,56.535V21.23  l8.797,2.273L75.815,56.535z M54.759,49.752c-0.627,0.576-0.668,1.547-0.086,2.17c0.307,0.328,0.723,0.494,1.139,0.494  c0.377,0,0.754-0.135,1.053-0.408l5-4.574l3.834,2.33c0.729,0.443,1.686,0.219,2.133-0.504s0.219-1.67-0.512-2.111l-4.834-2.939  c-0.592-0.361-1.355-0.287-1.865,0.18L54.759,49.752z',
            ],
            width: 100,
            height: 100,
        },
    ],
    [
        'search',
        {
            paths: [
                'M10.2564502,18.4797845 C5.55099127,18.4797845 1.73650238,14.7318753 1.73650238,10.1012249 C1.73650238,5.47057451 5.55099127,1.71518438 10.2564502,1.71518438 C14.9619092,1.71518438 18.7771461,5.47057451 18.7771461,10.1012249 C18.7771461,14.7318753 14.9619092,18.4797845 10.2564502,18.4797845 L10.2564502,18.4797845 Z M22.791118,21.8022381 L17.1115913,16.2114217 C18.5983496,14.5953801 19.5122727,12.4635805 19.5122727,10.1117241 C19.5122727,5.07792634 15.3683293,1 10.2561363,1 C5.14394336,1 1,5.07792634 1,10.1117241 C1,15.1386451 5.14394336,19.2165715 10.2561363,19.2165715 C12.4649558,19.2165715 14.4908531,18.4532497 16.0821384,17.1810467 L21.7843585,22.7924934 C22.0628678,23.0675643 22.5132964,23.0675643 22.791118,22.7924934 C23.0696273,22.5242992 23.0696273,22.077309 22.791118,21.8022381 L22.791118,21.8022381 Z',
            ],
            width: 24,
            height: 24,
        },
    ],
    [
        'upload',
        {
            paths: [
                'M85,42.3A13,13,0,0,0,68.8,29a25.6,25.6,0,0,0-17-7.5A26,26,0,0,0,25.1,41.8a15.4,15.4,0,0,0,1,30.6H42.4v-6H26.3a9.4,9.4,0,0,1,1-18.7h2.9l.4-2.7A20.1,20.1,0,0,1,65.7,34.4l1.4,1.7,2.1-.9a5.9,5.9,0,0,1,3.2-.6A7.1,7.1,0,0,1,79.1,42,8.5,8.5,0,0,1,78,45.4l-1.5,2.3,2.2,1.7a9.2,9.2,0,0,1,3.7,8,9.4,9.4,0,0,1-8.9,9H57.6v6H73.7A15.6,15.6,0,0,0,88.4,57.7a15.3,15.3,0,0,0-4.2-11.4A11,11,0,0,0,85,42.3Z',
                'M50,78.5a2.9,2.9,0,0,0,3-3V52.1l3,3.1a3.2,3.2,0,0,0,2.2,1,2.7,2.7,0,0,0,2-.9,3,3,0,0,0,.2-4.2l-8.2-8.6a3.1,3.1,0,0,0-4.4,0l-8.2,8.6a3,3,0,0,0,.2,4.2,2.9,2.9,0,0,0,4.2-.1l3-3.1V75.5A2.9,2.9,0,0,0,50,78.5Z',
            ],
            width: 100,
            height: 100,
        },
    ],
    [
        'mobile-upload',
        {
            paths: [
                'M71.25,25v15h-25c-5,0-5,0-5,5v10c0,5,0,5,5,5h25v15l27.5-25L71.25,25z M31.25,85c2.5,0,5,2.5,5,5s-2.5,5-5,5s-5-2.5-5-5  S28.75,85,31.25,85z M56.25,0h-50c-5,0-5,0-5,5v90c0,5,0,5,5,5h50c5,0,5,0,5-5V70h-10v10h-40V15h40v15h10V5C61.25,0,61.25,0,56.25,0  z',
            ],
            width: 100,
            height: 100,
        },
    ],
    [
        'apple-logo',
        {
            paths: [
                'm 150.37 130.25 c -2.45 5.66 -5.35 10.87 -8.71 15.66 c -4.58 6.53 -8.33 11.05 -11.22 13.56 c -4.48 4.12 -9.28 6.23 -14.42 6.35 c -3.69 0 -8.14 -1.05 -13.32 -3.18 c -5.197 -2.12 -9.973 -3.17 -14.34 -3.17 c -4.58 0 -9.492 1.05 -14.746 3.17 c -5.262 2.13 -9.501 3.24 -12.742 3.35 c -4.929 0.21 -9.842 -1.96 -14.746 -6.52 c -3.13 -2.73 -7.045 -7.41 -11.735 -14.04 c -5.032 -7.08 -9.169 -15.29 -12.41 -24.65 c -3.471 -10.11 -5.211 -19.9 -5.211 -29.378 c 0 -10.857 2.346 -20.221 7.045 -28.068 c 3.693 -6.303 8.606 -11.275 14.755 -14.925 s 12.793 -5.51 19.948 -5.629 c 3.915 0 9.049 1.211 15.429 3.591 c 6.362 2.388 10.447 3.599 12.238 3.599 c 1.339 0 5.877 -1.416 13.57 -4.239 c 7.275 -2.618 13.415 -3.702 18.445 -3.275 c 13.63 1.1 23.87 6.473 30.68 16.153 c -12.19 7.386 -18.22 17.731 -18.1 31.002 c 0.11 10.337 3.86 18.939 11.23 25.769 c 3.34 3.17 7.07 5.62 11.22 7.36 c -0.9 2.61 -1.85 5.11 -2.86 7.51 Z m -31.26 -123.01 c 0 8.1021 -2.96 15.667 -8.86 22.669 c -7.12 8.324 -15.732 13.134 -25.071 12.375 c -0.119 -0.972 -0.188 -1.995 -0.188 -3.07 c 0 -7.778 3.386 -16.102 9.399 -22.908 c 3.002 -3.446 6.82 -6.3113 11.45 -8.597 c 4.62 -2.2516 8.99 -3.4968 13.1 -3.71 c 0.12 1.0831 0.17 2.1663 0.17 3.2409 Z',
            ],
            width: 170,
            height: 170,
        },
    ],
    [
        'android-logo',
        {
            paths: [
                'M 80.506 22.203 c 0.942 -0.942 0.942 -2.483 0 -3.425 c -0.942 -0.942 -2.483 -0.942 -3.425 0 l -6.809 6.809 l 0.057 0.065 c -5.237 -4.987 -12.583 -8.107 -20.693 -8.107 h 0 c -7.888 0 -15.059 2.948 -20.265 7.699 l 0.006 -0.007 l -6.459 -6.459 c -0.942 -0.942 -2.483 -0.942 -3.425 0 c -0.942 0.942 -0.942 2.483 0 3.425 l 6.604 6.604 l 0.059 -0.064 c -3.3 4.278 -5.249 9.483 -5.249 15.087 v 38.626 h 57.458 V 43.829 c 0 -5.4 -1.805 -10.432 -4.888 -14.619 l 0.01 0.011 L 80.506 22.203 Z M 37.919 41.166 c -2.173 0 -3.935 -1.762 -3.935 -3.935 s 1.762 -3.935 3.935 -3.935 s 3.935 1.762 3.935 3.935 S 40.093 41.166 37.919 41.166 Z M 61.354 41.166 c -2.173 0 -3.935 -1.762 -3.935 -3.935 s 1.762 -3.935 3.935 -3.935 c 2.173 0 3.935 1.762 3.935 3.935 S 63.528 41.166 61.354 41.166 Z',
            ],
            width: 100,
            height: 100,
        },
    ],
    [
        'unknown',
        {
            paths: [
                'M 381 54.2 c -31 -27.4 -73.2 -41.2 -125.3 -41.2 c -49.7 0 -90.4 13.7 -121 40.8 c -30.7 27.1 -47.5 60.6 -49.9 99.6 c -0.1 2.1 1.4 4 3.5 4.2 l 82 10.4 c 2.1 0.3 4 -1.1 4.4 -3.1 c 5.5 -25.5 15.7 -44.7 30.2 -57.1 c 14.7 -12.3 33 -18.5 54.6 -18.5 c 22.5 0 40.5 5.9 53.6 17.6 c 13 11.4 19.6 25.3 19.6 41.4 c 0 11.6 -3.7 22.4 -11 32 c -4.8 6.2 -20.4 20 -46.3 41 c -26.3 21.4 -44.2 41.1 -53.2 58.5 c -9 17.5 -13.6 39.9 -13.6 66.8 l 0.3 21.4 c 0 2.2 1.8 3.9 4 3.9 h 81.3 c 1.1 0 2.1 -0.4 2.9 -1.2 c 0.8 -0.8 1.2 -1.8 1.1 -2.9 c -0.4 -23.8 1.5 -40.5 5.8 -49.4 c 3 -6.2 11.3 -17.6 34.1 -36.5 c 36.6 -30.4 60.9 -54.9 72.3 -72.8 c 11.5 -18.1 17.3 -37.7 17.3 -58.1 C 427.9 114.1 412.1 81.6 381 54.2 Z M 403.9 204.6 c -10.9 17.2 -34.7 41.1 -70.7 71 c -19.2 15.9 -31.4 29.1 -36.2 39.2 c -4.6 9.7 -6.8 25.7 -6.6 49 H 217 l -0.3 -17.4 c 0 -25.5 4.3 -46.7 12.7 -63 c 8.4 -16.4 25.6 -35.3 51.1 -56 c 26.7 -21.7 42.3 -35.5 47.6 -42.3 c 8.4 -11.1 12.6 -23.4 12.6 -36.8 c 0 -18.4 -7.5 -34.3 -22.3 -47.3 c -14.6 -13 -34.4 -19.6 -58.9 -19.6 c -23.5 0 -43.6 6.9 -59.8 20.4 c -15.2 13 -26 32.5 -32 57.9 L 93 150.1 c 3.1 -35.2 18.9 -65.6 47 -90.3 c 29.1 -25.8 68 -38.8 115.7 -38.8 c 50.1 0 90.5 13.2 120 39.2 c 29.3 25.9 44.2 56.4 44.2 90.6 C 419.9 169.7 414.5 187.8 403.9 204.6 Z',
                'M 256.3 401.2 c -27.2 0 -49.3 22.1 -49.3 49.2 c 0 27.2 22.1 49.3 49.3 49.3 c 27.2 0 49.3 -22.1 49.3 -49.3 C 305.6 423.3 283.5 401.2 256.3 401.2 Z M 256.3 491.8 c -22.8 0 -41.3 -18.5 -41.3 -41.3 c 0 -22.7 18.5 -41.2 41.3 -41.2 c 22.8 0 41.3 18.5 41.3 41.2 C 297.6 473.2 279.1 491.8 256.3 491.8 Z',
            ],
            width: 512,
            height: 512,
        },
    ],
    // https://thenounproject.com/search/?q=track&i=2108
    [
        'track',
        {
            paths: [
                'M83.652,10.501c-5.7-2.106-11.986,0.472-14.641,5.788L51.357,21.52c-0.75-0.498-1.561-0.927-2.439-1.252  c-6.113-2.258-12.901,0.868-15.16,6.981c-2.227,6.027,0.785,12.699,6.726,15.052l5.5,17.864c-0.239,0.433-0.456,0.883-0.644,1.354  l-19.675,5.883c-0.664-0.409-1.377-0.762-2.138-1.043c-6.114-2.258-12.901,0.867-15.161,6.979  C6.108,79.453,9.233,86.241,15.348,88.5c5.944,2.195,12.514-0.706,14.95-6.489l19.988-5.979c0.603,0.354,1.237,0.671,1.917,0.922  c6.113,2.259,12.9-0.867,15.16-6.979c2.259-6.113-0.866-12.902-6.98-15.16c-0.005-0.002-0.011-0.004-0.016-0.006l-5.383-17.475  c0.203-0.344,0.39-0.702,0.559-1.071l17.17-5.089c0.835,0.595,1.752,1.101,2.76,1.473c6.112,2.258,12.902-0.868,15.16-6.981  C92.893,19.548,89.766,12.759,83.652,10.501z',
            ],
            width: 100,
            height: 100,
        },
    ],
    // https://thenounproject.com/search/?q=camera&i=2837432
    [
        'photo',
        {
            paths: [
                'M192 125c-36,0 -65,29 -65,66 0,36 29,65 65,65 36,0 65,-29 65,-65 0,-37 -29,-66 -65,-66z',
                'M100 46l-62 0c-21,0 -38,17 -38,38l0 217c0,21 17,38 38,38l309 0c20,0 37,-17 37,-38l0 -217c0,-21 -17,-38 -37,-38l-63 0c-6,0 -11,-4 -13,-10l-9 -33c-1,-2 -3,-3 -5,-3l-130 0c-2,0 -4,1 -4,3l-9 32c-2,6 -7,11 -14,11zm92 52c51,0 93,42 93,93 0,50 -42,92 -93,92 -51,0 -92,-42 -92,-92 0,-51 41,-93 92,-93z',
            ],
            width: 384,
            height: 339,
        },
    ],
    // https://thenounproject.com/search/?q=comment&i=847908
    [
        'comment',
        {
            paths: [
                'M361.58,42.09c-2.1-.2-4.2-0.4-6.4-0.5q-45.6.15-91.2,0.1c-7.7,0-50.2,0-98.6-.1-12.5.6-21.6,1.3-24.8,1.9-91.9,16.1-154,106.5-138.1,198.6,14.9,86.5,84.5,145.6,172.3,146.1,23.7,0.1,47.4-.3,71.1.3a27.76,27.76,0,0,1,15.4,5.3c24.4,19,48.2,38.9,72.6,57.9,8.4,6.5,17.7,12.4,27.4,16.2,18.1,7,33.5-.9,39.8-19.5a81.21,81.21,0,0,0,4.1-21.2c0.7-13.7.8-27.5,0.3-41.3-0.3-7.4,1.9-11.4,8.8-14.9,67.5-34.4,102.9-98.1,97.1-173.6C505.18,117.59,441,49.49,361.58,42.09Z',
            ],
            width: 512,
            height: 512,
        },
    ],
    // ayvri original
    [
        'arrow-down',
        {
            paths: [
                'm 16.456689,9.0823531 h 1.425664 L 11.952942,14.917647 6.1176471,9.0823531 h 1.414214 l 4.4267149,4.4267139 z',
            ],
            width: 24,
            height: 24,
        },
    ],
    // ayvri original
    [
        'arrow-up',
        {
            paths: [
                'M 7.5433113,14.917647 H 6.1176472 l 5.9294108,-5.8352938 5.835295,5.8352938 h -1.414214 l -4.426715,-4.426714 z',
            ],
            width: 24,
            height: 24,
        },
    ],
]);
/* tslint:enable:max-line-length */
